<script lang="ts" setup>
	import ProductTableHeader from '@/components/table/producttable/ProductTableHeader.vue';
	import ProductTableRow from '@/components/table/producttable/ProductTableRow.vue';
	import {useProductTableStore} from '@/store/table.store';
	import type {StaticTableHeader, TableSort} from '@/types/table';
	import type {Product} from 'dummen-shared';
	import {computed} from 'vue';

	const props = defineProps<{
		products: Array<Product>;
		sort: TableSort | null;
		tableHeaders: Array<StaticTableHeader>;
		mobileViewActive: boolean;
	}>();

	const emit = defineEmits(['sort-updated']);

	const tableStore = useProductTableStore();

	const hasTableHeader = (key: string) => props.tableHeaders?.some(header => header.key === key);

	const showForm = computed(() => hasTableHeader('form'));

	const showLocation = computed(() => hasTableHeader('location'));

	const showPatCode = computed(() => hasTableHeader('patcode'));

	const noAvailabilityForRegionalWebSite = computed(() => tableStore.noAvailabilityForRegionalWebSite);
</script>

<template>
	<table class="catalog-overview-table catalog-overview-table--availability">
		<thead>
			<tr>
				<th></th>
				<th></th>

				<ProductTableHeader v-for="header in tableHeaders"
				                    :key="header.key"
				                    :colspan="header.colspan"
				                    :field-key="header.key"
				                    :field-translation="header.content"
				                    :sort="sort"
				                    :sortable="header.sortable"
				                    @sort-updated="emit('sort-updated', $event)" />
			</tr>
		</thead>

		<tbody>
			<ProductTableRow v-for="(product, index) in products"
			                 :key="`${index}-${product.id}`"
			                 :mobile-view-active="mobileViewActive"
			                 :no-availability-for-regional-web-site="noAvailabilityForRegionalWebSite"
			                 :product="product"
			                 :show-form="showForm"
			                 :show-location="showLocation"
			                 :show-pat-code="showPatCode" />
		</tbody>
	</table>
</template>
